import React from 'react'
import Cofe from '../Cofe/Cofe'
import Menu from '../Menu/Menu'
import About from '../About/About'
import FullMenu from '../FullMenu/FullMenu'
import Footer from '../Footer/Footer'


const Home = () => {
  return (
    <div id='homee'>
<Cofe/>
<Menu/>
<About/>
<FullMenu/>
<Footer/>
    </div>
  )
}

export default Home
